import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  label: theme => ({
    fontSize: 18.7,
    lineHeight: 25,
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.inActiveColorThree,
  }),
  inputContainerStyle: {
    flex: 1,
    marginLeft: 0,
    marginTop: 26,
  },
  voucherInputContainer: {
    flex: 1,
    flexDirection: 'row',
  },
  fotterContainer: {
    marginTop: 0,
    borderBottomColor: Colors.white_two,
    borderBottomWidth: 0.2,
  },
  icon: {
    marginHorizontal: 4,
    marginVertical: 3,
  },
  iconContainer: theme => ({
    backgroundColor: theme.colors.inActiveColorTwo,
    width: 42,
    height: 42,
    borderRadius: 6.2,
  }),
  subTitle: theme => ({
    fontSize: 16,
    paddingTop: 16,
    color: theme.colors.text.primary,
    lineHeight: 22,
    fontFamily: Fonts.type.VFFont,
  }),
  textInputContainerStyle: {
    height: 52,
  },
  voucherButtonContainer: {
    height: 103,
    justifyContent: 'center',
  },
});
